import { render, staticRenderFns } from "./ContactsContainer.vue?vue&type=template&id=13d07079&scoped=true"
import script from "./ContactsContainer.vue?vue&type=script&lang=ts"
export * from "./ContactsContainer.vue?vue&type=script&lang=ts"
import style0 from "./ContactsContainer.vue?vue&type=style&index=0&id=13d07079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d07079",
  null
  
)

export default component.exports